import { gql } from '@apollo/client'

import { MENU_CURATION_TASK_DETAILS_FRAGMENT } from '../fragments'

const UPDATE_MENU_CURATION_TASK_MUTATION = gql`
  mutation updateMenuCurationTask(
    $id: ID!
    $data: MenuCurationTaskUpdateInput!
  ) {
    updateMenuCurationTask(id: $id, data: $data) {
      ...MenuCurationTaskDetailsFragment
    }
  }
  ${MENU_CURATION_TASK_DETAILS_FRAGMENT}
`

export default UPDATE_MENU_CURATION_TASK_MUTATION
